module.exports = __webpack_public_path__ + "img/Wp_2003.bf49bdd7.png";